var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-form", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("card-title-component", {
                attrs: { title: _vm.$t("addGuardian.title") }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "card-content" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "o-label",
                          attrs: {
                            id: "email-form-group",
                            label: _vm.$t("addGuardian.email"),
                            "label-for": "email-input"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "o-form",
                            attrs: {
                              id: "email-input",
                              type: "text",
                              required: "",
                              placeholder: _vm.$t(
                                "addGuardian.emailPlaceholder"
                              )
                            },
                            model: {
                              value: _vm.localEmail,
                              callback: function($$v) {
                                _vm.localEmail = $$v
                              },
                              expression: "localEmail"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "o-label",
                          attrs: {
                            id: "firstname-form-group",
                            label: _vm.$t("addGuardian.firstname"),
                            "label-for": "firstname-input"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "o-form",
                            attrs: {
                              id: "firstname-input",
                              type: "text",
                              required: "",
                              placeholder: _vm.$t(
                                "addGuardian.firstnamePlaceholder"
                              )
                            },
                            model: {
                              value: _vm.localFirstname,
                              callback: function($$v) {
                                _vm.localFirstname = $$v
                              },
                              expression: "localFirstname"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "o-label",
                          attrs: {
                            id: "name-form-group",
                            label: _vm.$t("addGuardian.lastname"),
                            "label-for": "name-input"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "o-form",
                            attrs: {
                              id: "name-input",
                              type: "text",
                              required: "",
                              placeholder: _vm.$t(
                                "addGuardian.lastnamePlaceholder"
                              )
                            },
                            model: {
                              value: _vm.localName,
                              callback: function($$v) {
                                _vm.localName = $$v
                              },
                              expression: "localName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 button-div" },
            [
              _c(
                "b-button",
                { staticClass: "o-button", on: { click: _vm.cancel } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("addGuardian.cancelButton")) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                { staticClass: "o-button", on: { click: _vm.invite } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("addGuardian.inviteButton")) +
                      "\n                "
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c189656e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c189656e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/guardian/AddGuardianComponent.vue
// module id = null
// module chunks = 